<template>
    <div class="">
        <div class="box">
            <div class="title">账户登录</div>
            <div class="input">
                <i class="ficon-phone-o iconfont"></i>
                <input
                    type="text"
                    placeholder="请输入手机号"
                    v-model="account"
                />
            </div>
            <div class="input">
                <i class="ficon-phone-o iconfont"></i>
                <input
                    type="password"
                    placeholder="请输入密码"
                    v-model="password"
                />
            </div>
            <div
                style="padding: 0 10px;color:#0097FE;"
                @click="jump(3)"
                class="flex flex-end"
            >
                忘记密码？
            </div>
            <div class="confirm" @click="confirm">立即登录</div>
            <div style="color:#0097FE;" class="text-center" @click="jump(2)">
                还没有账号？立即注册
            </div>
        </div>
    </div>
</template>
<script>
import { send, register, accountLogin } from "@/api/index.js";
import { setStorage } from "@/util/util.js";
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
export default {
    data() {
        return {
            account: "",
            password: ""
        };
    },
    created() {},
    methods: {
        confirm() {
            accountLogin({
                account: this.account,
                password: this.password
            }).then(res => {
                if (res.code == 1) {
                    this.$message({
                        message: "登录成功",
                        type: "success"
                    });

                    localStorage.setItem(
                        "userInfo",
                        JSON.stringify(res.data.userinfo)
                    );

                    this.$store.commit("userInfo", res.data.userinfo);
                    this.$router.push({ name: "index" });
                } else {
                    this.$message.error("账户或密码不对");
                }
            });
        },
        jump(id) {
            this.$emit("logType", { type: id });
        }
    }
};
</script>
<style lang="less" scoped>
.box {
    width: 420px;
    height: 430px;
    background: #ffffff;
    border-radius: 16px;
    margin: 0px auto;
    padding: 40px 40px;
    .title {
        color: #333;
        font-size: 26px;
        margin-bottom: 30px;
    }
    .input {
        height: 42px;
        border-radius: 25px;
        border: 1px solid #d8d8d8;
        padding: 0 30px;
        line-height: 42px;
        font-size: 16px;
        color: #999;
        margin-bottom: 16px;
        input {
            border: none;
        }
        .yzmbtn {
            width: 132px;
            height: 42px;
            background: #0097fe;
            border-radius: 0px 25px 25px 0px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue